/**
 * Google reviews for UniHawk India | A Learning Lab India (Gurgaon).
 * Source listing: place_id ChIJdSNcXOcjDTkRAbMxNpWJ-w8 — curated from public Google Maps reviews.
 */

export const GOOGLE_REVIEWS_LISTING = {
  placeName: "UniHawk India | A Learning Lab India",
  mapsUrl:
    "https://www.google.com/maps/place/?q=place_id:ChIJdSNcXOcjDTkRAbMxNpWJ-w8",
  totalScore: 5,
  reviewsCount: 52,
};

export const GOOGLE_REVIEWS = {
  title: "The experience speaks",
  highlight: "for itself.",
  mapsCta: "Read all reviews on Google",
  reviews: [
    {
      id: "gr-yogesh-mittal",
      name: "Yogesh Mittal",
      stars: 5,
      text:
        "Amazing consistent experience from Unihawk teams from Middle East and India. Richa from Unikawk India team supported us amazingly well in short period of time for iLETS guidance and hand holding through the content and preparation, committing more than planned time & impactful content guidance made a huge difference in the outcome. The results was amazing and we are super glad to have been connected to Unikawk India team.",
      publishAt: "5 months ago",
    },
    {
      id: "gr-aastha-lodha",
      name: "Aastha Lodha",
      stars: 5,
      text:
        "Such a powerful and inspiring experience. The way complex concepts were made so interactive and engaging was amazing. I could truly see the impact on my confidence as well as thinking. The mentors brought in global exposure and gave us a real glimpse into how Harvard level mentorship feels. Loved every bit of it!",
      publishAt: "Edited 7 months ago",
    },
    {
      id: "gr-zaina-fathima",
      name: "Zaina Fathima",
      stars: 5,
      text:
        "Excellent service and dedicated teachers who train and are a strong backbone for the students until they reach their goals. Special thanks to Ms.Richa for helping my daughter improve her writing skills which helped ace the university which she wanted and also s ore high in her board exams.",
      publishAt: "5 months ago",
    },
    {
      id: "gr-aayan-doshi",
      name: "Aayan Doshi",
      stars: 5,
      text:
        "The tech leadership bootcamp under sir gabriel was outstanding and we had a great experience We got to learn a lot of things and came to know a lot about innovative ideas and learnt new leadership skills We learnt a lot about start ups and businesses and worked on lot of projects",
      publishAt: "4 months ago",
    },
    {
      id: "gr-vishnu-roshan",
      name: "Vishnu Roshan",
      stars: 5,
      text:
        "Had a great experience preparing for the GRE here. Garima Ma'am and Syed Sir explained the concepts clearly, and the revision sessions were very helpful. They were always supportive and willing to clear doubts. I would definitely recommend this institute.",
      publishAt: "4 months ago",
    },
    {
      id: "gr-anam-kabani",
      name: "Anam Kabani",
      stars: 5,
      text:
        "It was a reallyyyy fun experience and I had a lottt offff funn during these 5 days. This was like a dream workshop for me because, I do have leadership skills… however it was rlly fun learning about the market entry and market sizing. Thank you so much",
      publishAt: "4 months ago",
    },
    {
      id: "gr-saaanviii",
      name: "Saaanviii",
      stars: 5,
      text:
        "Ms.Garima and Richa are one of the most helpful and supportive teachers I have learned from. Throughout the entire prep experience I felt extremely supported and they were there for all the questions and doubts I had!!",
      publishAt: "a month ago",
    },
    {
      id: "gr-priyanka-ojha",
      name: "Priyanka Ojha",
      stars: 5,
      text:
        "We had the best experience at UniHawk with our son’s IELTS preparation. Ms Richa Sabharwal is a thorough professional and a very good trainer . Her teaching style is structured, focused and  very effective.",
      publishAt: "5 months ago",
    },
    {
      id: "gr-jinal-doshi",
      name: "Jinal Doshi",
      stars: 5,
      text:
        "We contacted unihawk for my son's UK medicine entry though we were late  they supported us nicely and we were in touch with mr.Debopriyo and mr. Shahid during this process . We liked their services.",
      publishAt: "8 months ago",
    },
  ],
};
